import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonAppRunService } from './common-app-run.service';

export function initCommonAppRunService (appRunService: CommonAppRunService) {
	return () => {
			appRunService.init();
			return Promise.resolve(true);
	};
}

@NgModule({
	providers: [
		CommonAppRunService,
		{
			provide: APP_INITIALIZER,
			useFactory: initCommonAppRunService,
			multi: true,
			deps: [CommonAppRunService],
		},
	]
})
export class CommonAppRunModule {}
